<template>
  <div v-if="productLoaded" @mousemove.once="hasMoved = true" class="fillSpace">
    <AppMenu>
      <template v-slot:topleft>
        <div class="container-title">
          <RoundButton
            v-if="isFromQuizz && $route.query.embed !== 'true'"
            class="homeButton"
            href="/"
            width="60"
            image="ic-home.svg"
          />
          <RoundButton
            v-if="$route.query.embed !== 'true'"
            class="bordered back"
            :href="isFromQuizz ? '/relate/' + quizzLastStep : '/'"
            :width="currentScreenWidth > 1024 ? 35 : 25"
            image="ic-arrow-back.svg"
          />
          <h2 class="page-title" v-if="$route.query.embed !== 'true'">
            <span class="page-title-text">{{ getWebcontrol('ConfigurerVosVerres-Titre-ConfigurerVosVerres ') }}</span>
          </h2>

          <div
            v-if="(isSelectedCorrect || isSelectedProtect || isSelectedOptimize) && $route.query.embed !== 'true'"
            class="container-title"
          >
            <RoundButton
              class="bordered btn-reset"
              :width="currentScreenWidth > 1024 ? 35 : 25"
              @go="go()"
              image="ic-mode-autorenew.svg"
            />
            <span class="reset">Réinitialiser</span>
          </div>
        </div>
      </template>
      <template v-slot:bottomrightincontainer>
        <img class="logo-bottom-right" src="../assets/logo.png" />
      </template>
    </AppMenu>

    <div class="background">
      <div class="navigationPaneContainer">
        <Pane>
          <ConfiguratorPane
            :title="getLabel('ConfigurerVosVerres-Titre-corrigerVIsion')"
            subtitle="choisir une correction"
            category="correct"
            :description="getLabel('ConfigurerVosVerres-Texte-CorrigerDescription')"
            image="ic-correction.svg"
            :defaultModelID="getSelectedValues('correct')"
            @hasSelected="selectedPaneTypeCorrect"
            :hasMoved="hasMoved"
          />
        </Pane>
        <Pane>
          <ConfiguratorPane
            :title="getLabel('ConfigurerVosVerres-Titre-ProtegerVosYeux')"
            subtitle="choisir une protection"
            category="protect"
            :description="getLabel('ConfigurerVosVerres-Texte-ProtegerDescription')"
            image="ic-protection.svg"
            :defaultModelID="getSelectedValues('protect')"
            @hasSelected="selectedPaneTypeProtect"
            :hasMoved="hasMoved"
          />
        </Pane>
        <Pane>
          <ConfiguratorPane
            :title="getLabel('ConfigurerVosVerres-Titre-OptimiserVosVerres')"
            subtitle="choisir un traitement"
            category="optimize"
            :description="getLabel('ConfigurerVosVerres-Texte-OptimiserDescription')"
            image="ic-optimisation.svg"
            :defaultModelID="getSelectedValues('optimize')"
            @hasSelected="selectedPaneTypeOptimize"
            :hasMoved="hasMoved"
          />
        </Pane>
      </div>
    </div>
  </div>
</template>

<script>
import AppMenu from '@Components/Menu.vue';
import RoundButton from '@Components/Menus/RoundButton.vue';
import Pane from '@Components/Pane.vue';
import ConfiguratorPane from '@Components/Panes/Configurator.vue';

export default {
  beforeMount() {
    if (this.$route.query.optimize || this.$route.query.protect || this.$route.query.correct) {
      this.setSelectedProducts(this.$route.query);
    } else if (this.isFromQuizz) {
      this.setSelectedProducts(this.getModels);
    }
    window.localStorage.removeItem('crizal_left');
    window.localStorage.removeItem('crizal_right');
  },
  mounted() {
    this.$gtag.pageview({
      page_title: `Configurer vos verres${this.$route.query.embed === 'true' ? ' embarqué' : ''}`,
      page_path: `/Configurer vos verres${this.$route.query.embed === 'true' ? ' embarqué' : ''}`,
      page_location: window.location.href,
    });
  },
  computed: {
    quizzLastStep() {
      return this.$store.getters.getSteps.length;
    },
    productLoaded() {
      return this.$store.getters.isProductsLoaded();
    },
    currentScreenWidth() {
      return window.outerWidth;
    },
    isFromQuizz() {
      return this.$store.getters.isFilled;
    },
    getModels() {
      return this.$store.getters.getModelsFromQuizz;
    },
  },
  methods: {
    getWebcontrol(key) {
      return this.$store.getters.getValueById(key);
    },
    setSelectedProducts(categorySelectedProducts) {
      Object.keys(categorySelectedProducts).forEach(key => {
        this.$store.commit('selectProduct', { category: key, productId: categorySelectedProducts[key] });
      });
    },
    go() {
      this.$store.dispatch('QuizzFilled', false);
      this.setSelectedProducts({
        correct: null,
        protect: null,
        optimize: null,
      });

      window.location = window.location;
    },
    //First we check query then if there is no products we check the store "selected" and finally null if neither
    getSelectedValues(category) {
      return this.$store.getters.getProductSelected[category];
    },
    selectedPaneTypeCorrect(isSelected) {
      return (this.isSelectedCorrect = isSelected);
    },
    selectedPaneTypeProtect(isSelected) {
      return (this.isSelectedProtect = isSelected);
    },
    selectedPaneTypeOptimize(isSelected) {
      return (this.isSelectedOptimize = isSelected);
    },
    getLabel(id) {
      return this.$store.getters.getValueById(id);
    },
  },
  data() {
    return {
      hasMoved: false,
      isSelectedProtect: false,
      isSelectedCorrect: false,
      isSelectedOptimize: false,
    };
  },
  components: {
    AppMenu,
    RoundButton,
    Pane,
    ConfiguratorPane,
  },
};
</script>

<style scoped>
.fillSpace {
  width: 100%;
  height: 100%;
}

.container-title {
  display: -moz-flex;
  display: -webkit-flex;
  display: flex;
}
.hStackable {
  max-height: 80%;
  margin: 20px;
  width: 22vw;
  max-width: 30%;
  background-color: rgba(255, 255, 255, 0.97);
}

.navigationPaneContainer {
  display: flex;
  width: 100%;
  /* height: 100%; */
  top: 7vh;
  bottom: 7vh;
  left: 50%;
  position: absolute;
  transform: translate(-50%, 0);
  flex-direction: row;
  justify-content: center;
  align-items: center;
}

.background {
  top: 10vh;
  bottom: 10vh;
  left: 7vw;
  right: 7vw;
  overflow: hidden;
  /* left: 50%; */
  position: absolute;
  /* transform: translate(-50%, -50%); */
  background-color: rgba(0, 136, 236, 0.2);
  background-image: url(../assets/img-verre.svg);
  background-repeat: no-repeat;
  background-position: -40px -116px;
}

.page-title {
  padding-left: 20px;
  align-self: center;
}

.reset {
  font-family: 'AkhandSoft', Helvetica, Arial, sans-serif;
  text-transform: capitalize;
  font-size: 16px;
  color: black;
  opacity: 0.5;
  align-self: center;
}

.btn-reset {
  margin-left: 30px;
  margin-right: 10px;
}

.btn-reset:hover {
  border: 1px solid black;
}

.back:hover {
  border: 1px solid black;
}

.page-title .bordered {
  position: relative;
  margin-left: 12px;
  margin-right: -48px;
  padding-left: 11px;
}
/*
résolution moins de 1024
*/
@media (max-width: 1024px) {
  .navigationPaneContainer {
    top: 28px;
    bottom: 28px;
  }
}
</style>
